import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

const statementOptionsServiceUrl = "/api/v1/poolcorp/customers/UpdateCustomerStatementOptIn";

export interface SubmitStatementOptionsApiParameter extends ApiParameter {
    HasOptedIn: boolean;
    Email: string;
    ConfirmationEmail: string;
}

export function submitStatementOptionsForm(parameter: SubmitStatementOptionsApiParameter) {
    const { HasOptedIn, Email, ConfirmationEmail, ..._parameter } = parameter;

    return post<SubmitStatementOptionsApiParameter>(`${statementOptionsServiceUrl}`, parameter);
}
